<template>
  <div class="form-group">
    <label class="mb-1" :for="id">{{ label }}</label>
    <Autocomplete
        :search="search"
        base-class="custom"
        :submit-on-enter="true"
        data-expanded="true"
        data-loading="false"
        data-position="below"
        @submit="onAutocompleteSubmit"
    >
      <template
          #default="{
          rootProps,
          inputProps,
          inputListeners,
          resultListProps,
          resultListListeners,
          results,
          resultProps
        }"
      >
        <div v-bind="rootProps">
          <input
              v-bind="inputProps"
              v-on="inputListeners"
              :class="[
    'form-control',
    resultListProps.style.visibility === 'visible' ? 'border-bottom-0 rounded-top rounded-0' : '',
    { 'readonly-field': readonly }
  ]"    
              aria-expanded="true"
              :id="id"
              :name="id"
              :value="modelValue"
              :readonly="readonly"              
              @input="updateModelValue"
              type="text"
          />
          <ul
              v-bind="resultListProps"
              v-on="resultListListeners"
          >
            <li
                v-for="(result, index) in results"
                :key="resultProps[index].id"
                v-bind="resultProps[index]"
            >
              {{ result }}
            </li>
          </ul>
        </div>
      </template>
    </Autocomplete>
  </div>
</template>

<script setup>
import Autocomplete from "@trevoreyre/autocomplete-vue";

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  modelValue: {
    type: String,
    required: false,
    default: ''
  },
  readonly: {
      type: Boolean,
      required: false,
      default: false
    },
  items: {
    type: Array,
    required: false,
    default: () => []
  }
});

const emit = defineEmits(['update:modelValue']);

const search = (input) => {
  const q = (input ?? '').trim().toLowerCase();
  if (q.length < 1) {
    return [];
  }
  return props.items.filter((item) => {
    return String(item).toLowerCase().includes(q);
  });
};

const updateModelValue = (event) => {
  emit('update:modelValue', event.target.value);
};

const onAutocompleteSubmit = (selectedResult) => {
  if (selectedResult == null || selectedResult === '') {
    return;
  }
  emit('update:modelValue', String(selectedResult));
};
</script>

<style scoped>
.custom-input{
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Im0yMSAyMS00LTQiLz48L3N2Zz4=");
  background-position: 12px;
  background-repeat: no-repeat;
  padding-left: 48px;
}
.custom-result-list {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  outline: 0;
  border-left: var(--bs-border-width) solid #80afd7;
  border-right: var(--bs-border-width) solid #80afd7;
  border-bottom: var(--bs-border-width) solid #80afd7;
  border-bottom-left-radius: var(--bs-border-radius);
  border-bottom-right-radius: var(--bs-border-radius);
  box-shadow: 0 0 0 0.25rem rgba(0, 95, 174, 0.25);
  overflow: hidden;
  cursor: default;
  clip-path: inset(0px -0.25rem -0.25rem -0.25rem);
  list-style: none;
  padding-left: 0;
}

.custom-result {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Im0yMSAyMS00LTQiLz48L3N2Zz4=");
  background-position: 12px;
  background-repeat: no-repeat;
  cursor: default;
  padding: 12px 12px 12px 48px
}

.custom-result:hover, .custom-result[aria-selected=true] {
  background-color: rgba(0, 0, 0, .06)
}

.readonly-field {
  background-color: #e9ecef; 
  color: #6c757d;
  cursor: not-allowed;      
}
</style>